import { ValueOf } from 'shared/types/generic'

export const legacyMobilesBreakPoint = 360
export const microMobileBreakPoint = 450
export const mobileBreakPoint = 768
export const mobileSliderBreakPoint = 906
export const tabletBreakPoint = 1024
export const tabletSliderBreakPoint = 1200
export const hugeDesktopBreakPoint = 1600

export const DeviceType = {
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile'
} as const

export type DeviceType = ValueOf<typeof DeviceType>
